import {Injectable} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {CustomNotification, CustomNotificationType} from '../model/notification.model';

@Injectable()
export class NotificationService {
    public subject = new Subject<CustomNotification>();
    public keepAfterRouteChange = true;

    private SUCCESS_ICON = 'task_alt';
    private INFO_ICON = 'info';
    private ERROR_ICON = 'error';
    private WARN_ICON = 'warning';

    constructor(public router: Router) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                } else {
                    // clear alert messages
                    this.clear();
                }
            }
        });
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    success(message: string, keepAfterRouteChange = false): void {
        this.showNotification(CustomNotificationType.Success, message, this.SUCCESS_ICON, keepAfterRouteChange);
    }

    error(message: string, keepAfterRouteChange = false): void {
        this.showNotification(CustomNotificationType.Error, message, this.ERROR_ICON, keepAfterRouteChange);
    }

    info(message: string, keepAfterRouteChange = false): void {
        this.showNotification(CustomNotificationType.Info, message, this.INFO_ICON, keepAfterRouteChange);
    }

    warn(message: string, keepAfterRouteChange = false): void {
        this.showNotification(CustomNotificationType.Warning, message, this.WARN_ICON, keepAfterRouteChange);
    }

    showNotification(type: CustomNotificationType, message: string, icon: string, keepAfterRouteChange = false): void {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({type, icon, message} as CustomNotification);
    }

    clear(): void {
        this.subject.next();
    }
}
